export default __webpack_public_path__ + "static/media/icon-card-deicing.53cd88a2.svg";